import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface AuthErrorDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AuthErrorDialog: React.FC<AuthErrorDialogProps> = ({ open, onOpenChange }) => {
  const handleOk = () => {
    onOpenChange(false);
    window.location.href = '/login';
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[425px] mx-4">
        <AlertDialogHeader>
          <AlertDialogTitle>Authentication Failed</AlertDialogTitle>
          <AlertDialogDescription>
            Your session has expired or authentication failed. Please log in again to continue.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={handleOk}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

